/**
 * Task EM: e-mail package — Platform admin → 邮件中心 (templates, broadcasts, log, provider), owner marketing e-mail setting.
 * One row per key: [key, English, 中文]; Malay falls back to English. Registered in ../modules.ts.
 */
const ROWS = [
  ["em.nav", "E-mail centre", "邮件中心"],
  ["em.title", "E-mail centre", "邮件中心"],
  ["em.sub", "Every automated e-mail Senvia sends, broadcasts to shop owners, the sent-mail log and the sending provider.", "Senvia 自动发送的所有邮件、给店主的群发邮件、发送日志以及邮件服务商设置。"],
  ["em.tab.templates", "Templates", "邮件模板"],
  ["em.tab.broadcast", "Broadcast", "群发邮件"],
  ["em.tab.log", "Sent log", "发送日志"],
  ["em.tab.provider", "Provider", "邮件发送"],
  ["em.group.account", "Account (sign-up, password)", "账户（注册、密码）"],
  ["em.group.billing", "Billing: Senvia → shop owners", "账单：Senvia → 店主"],
  ["em.group.member", "Memberships: shop → their customers (sent in the shop's name)", "会员订阅：店铺 → 顾客（以店铺名义发送）"],
  ["em.tpl.hint", "Defaults are built in. Edit a template to override the subject and text (English and 中文); “Reset” goes back to the default.", "默认内容已内置。编辑模板即可覆盖主题与内容（英文与中文）；“恢复默认”可回到默认内容。"],
  ["em.tpl.email", "E-mail", "邮件"],
  ["em.tpl.trigger", "Sent when", "发送时机"],
  ["em.tpl.state", "Status", "状态"],
  ["em.tpl.on", "On", "开启"],
  ["em.tpl.off", "Off", "已关闭"],
  ["em.tpl.edited", "Edited", "已修改"],
  ["em.tpl.edit", "Edit", "编辑"],
  ["em.tpl.enabled", "Send this e-mail", "发送这封邮件"],
  ["em.tpl.required", "Needed for signing in — can't be switched off.", "登录必需，不能关闭。"],
  ["em.tpl.reset", "Reset to default", "恢复默认"],
  ["em.tpl.resetDone", "Back to the default text", "已恢复默认内容"],
  ["em.subject", "Subject", "主题"],
  ["em.body", "Text", "内容"],
  ["em.mdHint", "Blank line = new paragraph · **bold** · [text](https://…) · # heading · - list · [[Button|https://…]] on its own line = button", "空行 = 新段落 · **粗体** · [文字](https://…) · # 标题 · - 列表 · 单独一行 [[按钮文字|https://…]] = 按钮"],
  ["em.vars", "Placeholders:", "占位符："],
  ["em.save", "Save", "保存"],
  ["em.saved", "Saved", "已保存"],
  ["em.preview", "Preview", "预览"],
  ["em.previewLang", "Preview language:", "预览语言："],
  ["em.lang.both", "English + 中文", "英文 + 中文"],
  ["em.lang.en", "English", "英文"],
  ["em.lang.zh", "中文", "中文"],
  ["em.testMe", "Send test to me", "发送测试给我"],
  ["em.testSent", "Test sent to {to}", "测试邮件已发送到 {to}"],
  ["em.testFailed", "Test not sent: {error}", "测试邮件未发送：{error}"],
  ["em.bc.compose", "New broadcast", "新群发"],
  ["em.bc.boldText", "bold text", "粗体文字"],
  ["em.bc.link", "Link", "链接"],
  ["em.bc.linkText", "link text", "链接文字"],
  ["em.bc.button", "Button", "按钮"],
  ["em.bc.buttonText", "Open Senvia POS", "打开 Senvia POS"],
  ["em.bc.headingBtn", "Heading", "标题"],
  ["em.bc.heading", "Heading", "标题"],
  ["em.bc.category", "Category", "类别"],
  ["em.bc.cat.service", "系统维护 / Service notice — goes to every selected owner", "系统维护 / 服务通知 — 发给所有选中的店主"],
  ["em.bc.cat.marketing", "优惠/营销 / Offers & news — skips owners who unsubscribed (unsubscribe link added)", "优惠/营销 — 跳过已退订的店主（自动附退订链接）"],
  ["em.bc.audience", "Audience: shop owners", "收件人：店主"],
  ["em.bc.byPlan", "Plan (none ticked = all):", "套餐（不勾选 = 全部）："],
  ["em.bc.byStatus", "Status (none ticked = all):", "状态（不勾选 = 全部）："],
  ["em.bc.st.trialing", "Trial", "试用中"],
  ["em.bc.st.active", "Active", "已订阅"],
  ["em.bc.st.past_due", "Payment overdue", "欠费"],
  ["em.bc.st.cancelled", "Cancelled", "已取消"],
  ["em.bc.count", "{n} shop owner(s) will receive it.", "将发送给 {n} 位店主。"],
  ["em.bc.countMkt", "{n} shop owner(s) will receive it ({u} unsubscribed, skipped).", "将发送给 {n} 位店主（{u} 位已退订，跳过）。"],
  ["em.bc.when", "Send later (optional)", "定时发送（可选）"],
  ["em.bc.whenHint", "Empty = send now. Sending runs in the background in small batches; you can leave this page.", "留空 = 立即发送。邮件在后台分批发送，可以离开此页面。"],
  ["em.bc.send", "Send", "发送"],
  ["em.bc.schedule", "Schedule", "定时发送"],
  ["em.bc.confirmTitle", "Send this broadcast?", "确定发送这封群发邮件？"],
  ["em.bc.queued", "Broadcast queued — sending in the background", "已加入发送队列，正在后台发送"],
  ["em.bc.scheduled", "Broadcast scheduled", "已设定定时发送"],
  ["em.bc.history", "History", "发送记录"],
  ["em.bc.none", "No broadcasts yet.", "还没有群发记录。"],
  ["em.bc.progress", "Progress", "进度"],
  ["em.bc.date", "Date", "日期"],
  ["em.bc.stats", "{sent} / {total} sent · {failed} failed · {skipped} skipped", "已发送 {sent} / {total} · 失败 {failed} · 跳过 {skipped}"],
  ["em.bc.queuedN", "{n} still queued", "仍有 {n} 封排队中"],
  ["em.bc.cancel", "Cancel", "取消"],
  ["em.bc.unsub", "Unsubscribed from offers", "已退订优惠邮件"],
  ["em.bc.status.scheduled", "Scheduled", "已排程"],
  ["em.bc.status.sending", "Sending", "发送中"],
  ["em.bc.status.done", "Done", "已完成"],
  ["em.bc.status.cancelled", "Cancelled", "已取消"],
  ["em.log.search", "Recipient, subject or template", "收件人、主题或模板"],
  ["em.log.all", "All", "全部"],
  ["em.log.find", "Search", "搜索"],
  ["em.log.refresh", "Refresh", "刷新"],
  ["em.log.last7", "Last 7 days: {sent} sent · {failed} failed · {skipped} skipped. Kept {days} days.", "最近 7 天：已发送 {sent} · 失败 {failed} · 跳过 {skipped}。日志保留 {days} 天。"],
  ["em.log.empty", "No e-mails match.", "没有符合条件的邮件。"],
  ["em.log.time", "Time", "时间"],
  ["em.log.to", "To", "收件人"],
  ["em.log.what", "E-mail", "邮件"],
  ["em.log.error", "Error", "错误"],
  ["em.log.campaign", "broadcast", "群发"],
  ["em.log.st.sent", "Sent", "已发送"],
  ["em.log.st.failed", "Failed", "失败"],
  ["em.log.st.skipped", "Skipped", "跳过"],
  ["em.pref.title", "E-mails from Senvia", "Senvia 邮件"],
  ["em.pref.marketing", "Send me offers and product news by e-mail", "通过邮件接收优惠与产品消息"],
  ["em.pref.hint", "Service e-mails (billing, security, maintenance) always arrive.", "账单、安全与系统维护等服务邮件始终会发送。"],
  ["apiError.template_mandatory", "This e-mail is needed for signing in and can't be switched off.", "这封邮件是登录必需的，不能关闭。"],
  ["apiError.no_owner_recipients", "No shop owner matches these filters.", "没有符合条件的店主。"],
  ["apiError.not_cancellable", "This broadcast has already finished.", "这封群发邮件已经发送完成。"],
  ["apiError.schedule_too_far", "Schedule within the next 90 days.", "请在 90 天内定时发送。"],
] as const;

export type EmKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<EmKey, string>;

export const taskEM = { en: col(1), zh: col(2), ms: col(1) };
